import { useApiClient } from '../../hooks/useApiClient';
import { ApiResponse } from '../../types/ApiResponse.type';
import {
  GetGroupsStatuteStatisticsParams,
  GetStatutesQueryParams,
  GetStatuteStatisticsParams,
} from '../../types/QueryParams.type';
import { Statute } from '../../types/Statute.type';
import { GroupsStatuteStatisticsResponse, StatuteStatisticsResponse } from '../../types/StatuteStatistics.type';
import { buildQueryString } from '../../utils/buildQueryString';

export const useStatuteApi = () => {
  const apiClient = useApiClient();

  return {
    getStatutes: (params: GetStatutesQueryParams): Promise<ApiResponse<Statute[]>> => {
      const queryString = buildQueryString(params);

      return apiClient(`/statutes${queryString}`);
    },

    getStatuteById: (id: number): Promise<Statute> => {
      return apiClient(`/statutes/${id}`);
    },

    getStatuteStatistics: (params: GetStatuteStatisticsParams): Promise<StatuteStatisticsResponse> => {
      const queryString = buildQueryString({
        county_fips: params.county_fips,
        statute_ids: params.statute_ids,
      });

      return apiClient(`/statutes/statistics${queryString}`);
    },

    getGroupsStatuteStatistics: (
      params: GetGroupsStatuteStatisticsParams,
    ): Promise<GroupsStatuteStatisticsResponse> => {
      const queryString = buildQueryString({
        case_id: params.case_id,
        county_fips: params.county_fips,
        statute_ids: params.statute_ids,
        inclusion_groups_ids: params.inclusion_groups_ids?.map((group) => JSON.stringify(group)),
        exclusion_groups_ids: params.exclusion_groups_ids?.map((group) => JSON.stringify(group)),
      });

      return apiClient(`/statutes/groups_statistics${queryString}`);
    },
  };
};
